<div class="modal-header blue">
  <h4 class="modal-title">
    {{
      isViewMode
        ? 'View Account'
        : isEditMode
          ? 'Edit Account'
          : 'Create New Account'
    }}
  </h4>
  <a
    href="javascript:void(0)"
    aria-label="javascript"
    class="modal-close-btn"
    (click)="close()"
  ></a>
</div>

<div class="modal-body" [class.loading]="isLoading" style="max-height: 780px">
  <form [formGroup]="accountForm">
    <div class="form-row md mb-3">
      <div class="col-8">
        <div class="form-row md mb-3">
          <div class="col-6">
            <div class="mb-3">
              <div class="input-label">
                <span class="standart-text-required-symbol">* </span>
                account number
              </div>

              <div *ngIf="!isEditMode; else accountNumberLabel">
                <input
                  type="text"
                  class="input"
                  aria-label="accountNumber"
                  formControlName="accountNumber"
                  maxLength="20"
                  [class.is-invalid]="
                    accountForm.get('accountNumber')?.touched &&
                    accountForm.get('accountNumber')?.invalid
                  "
                />

                <div
                  class="invalid-feedback text-left"
                  *ngIf="
                    accountForm.get('accountNumber')?.invalid &&
                    accountForm.get('accountNumber')?.touched
                  "
                >
                  <span
                    *ngIf="accountForm.get('accountNumber')?.errors?.required"
                    >This field is required</span
                  >
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="input-label">
                <span class="standart-text-required-symbol">* </span>
                account Name
              </div>
              <input
                type="text"
                placeholder="Enter Name"
                class="input"
                formControlName="name"
                maxlength="65"
                [class.is-invalid]="
                  accountForm.get('name')?.touched &&
                  accountForm.get('name')?.invalid
                "
              />
              <div
                class="invalid-feedback text-left"
                *ngIf="
                  accountForm.get('name')?.invalid &&
                  accountForm.get('name')?.touched
                "
              >
                <span *ngIf="accountForm.get('name')?.errors?.required"
                  >This field is required</span
                >
              </div>
            </div>
            <div class="mb-3">
              <ddl-practice formControlName="pms"></ddl-practice>
            </div>
            <div>
              <div class="input-label">Tax exempt number</div>
              <input
                type="text"
                placeholder="Enter Tax Number"
                class="input"
                formControlName="taxExempt"
                maxlength="40"
              />
            </div>
          </div>
          <div class="col-6">
            <section-contact formGroupName="contact"></section-contact>
          </div>
        </div>

        <div class="mb-3">
          <section-address formGroupName="address"></section-address>
        </div>

        <div class="form-row md">
          <div class="col">
            <div tooltip="Please Enter Last 4 Digits of Credit Card">
              <div class="input-label text-nowrap">credit card number</div>
              <input
                type="text"
                mask="0000"
                class="input w-110px"
                placeholder="Last 4 Digits"
                formControlName="creditCardNo"
                [class.is-invalid]="
                  accountForm.get('creditCardNo')?.touched &&
                  accountForm.get('creditCardNo')?.invalid
                "
              />
              <div
                class="invalid-feedback text-left ng-star-inserted"
                *ngIf="
                  accountForm.get('creditCardNo')?.invalid &&
                  accountForm.get('creditCardNo')?.touched
                "
              >
                <span
                  class="ng-star-inserted"
                  *ngIf="accountForm.get('creditCardNo')?.errors"
                  >Invalid card number. Please Enter Last 4 Digits of Credit
                  Card.</span
                >
              </div>
            </div>
          </div>

          <div class="col">
            <div class="input-label">expiration</div>
            <input
              class="input"
              mask="99/99"
              formControlName="expirationDate"
              placeholder="Enter expiration date"
            />
          </div>

          <ng-container *ngIf="isEditMode">
            <div class="col pr-0">
              <div class="input-label text-nowrap">terminate notices</div>

              <div class="d-flex mt-2">
                <label class="input-wrap radio mr-3">
                  <input
                    type="radio"
                    formControlName="terminateNoticies"
                    value="Y"
                  />
                  <span class="text"> Yes </span>
                </label>

                <label class="input-wrap radio">
                  <input
                    type="radio"
                    formControlName="terminateNoticies"
                    value="N"
                  />
                  <span class="text"> No </span>
                </label>
              </div>
            </div>
          </ng-container>

          <div class="col">
            <div class="d-flex mt-3">
              <label class="checkbox">
                <input type="checkbox" formControlName="creditCardExport" />
                <span>Account Export</span>
              </label>
            </div>
          </div>
          <div class="col" *ngIf="!isEditMode"></div>
        </div>
      </div>

      <div class="col-4">
        <section-status-dates
          [formGroup]="accountForm"
          [isEditMode]="isEditMode ?? false"
        ></section-status-dates>
      </div>
    </div>

    <div class="mb-3">
      <div class="input-label">Notes</div>

      <div class="input-wrap">
        <textarea
          placeholder="Enter Notes"
          formControlName="notes"
          rows="5"
          maxlength="4000"
        ></textarea>
      </div>
    </div>

    <div class="modal-table">
      <div class="user-modal-table">
        <table class="standart-table">
          <thead class="standart-table-header">
            <th class="expand-cell"></th>
            <th>Provider Groups</th>
            <th>Group ID</th>
            <th style="width: 172px">
              <ng-container *ngIf="!isViewMode">
                <a
                  href="javascript:void(0);"
                  class="add-group-btn"
                  (click)="editProviderGroupClick()"
                >
                  <i class="fas fa-plus fz-16 mr-2"></i>
                  <span> Add Provider Group </span>
                </a>
              </ng-container>
            </th>
          </thead>

          <tbody>
            <ng-container *ngIf="providerGroups?.length; else emptyRow">
              <ng-container *ngFor="let pgroup of providerGroups">
                <tr>
                  <td class="expand-cell">
                    <a
                      href="javascript:void(0);"
                      aria-label="javascript"
                      (click)="pgroup.isExpanded = !pgroup.isExpanded"
                      [class.expanded]="pgroup.isExpanded"
                      class="standart-link-action"
                    >
                      <i class="fas fa-chevron-down"></i>
                    </a>
                  </td>

                  <td>
                    {{ pgroup.name }}
                  </td>
                  <td>
                    {{ pgroup.groupId }}
                  </td>
                  <td class="actions-cell">
                    <ng-container *ngIf="!isViewMode">
                      <div class="d-flex">
                        <div ngbDropdown container="body" class="ml-auto">
                          <a
                            href="javascript:void(0);"
                            aria-label="javascript"
                            class="standart-link-action ml-auto"
                            ngbDropdownToggle
                          >
                            <i class="fas fa-chevron-circle-down"></i>
                          </a>

                          <div class="padding-top" ngbDropdownMenu>
                            <div class="dropdown-menu-inside">
                              <button
                                type="button"
                                ngbDropdownItem
                                (click)="
                                  editProviderGroupClick(pgroup?.groupId)
                                "
                              >
                                Edit Group
                              </button>
                              <button
                                type="button"
                                ngbDropdownItem
                                (click)="deleteGroup(pgroup?.groupId)"
                              >
                                Deactivate Group
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </tr>
                <tr
                  class="standart-table-row-inner"
                  [(ngbCollapse)]="pgroup.isExpanded"
                >
                  <td colspan="4">
                    <div class="content p-0">
                      <div class="inner-table">
                        <table class="standart-table not-sticky">
                          <thead class="standart-table-header">
                            <th class="expand-cell"></th>
                            <th>Provider</th>
                            <th>Id</th>
                            <th style="width: 130px">
                              <ng-container *ngIf="!isViewMode">
                                <a
                                  href="javascript:void(0);"
                                  class="add-group-btn"
                                  (click)="addProvider()"
                                >
                                  <i class="fas fa-plus fz-16 mr-2"></i>
                                  <span> Add Provider </span>
                                </a>
                              </ng-container>
                            </th>
                          </thead>

                          <tbody>
                            <ng-container
                              *ngIf="
                                pgroup.providers && pgroup.providers.length;
                                else emptyRow
                              "
                            >
                              <tr *ngFor="let provider of pgroup.providers">
                                <td class="expand-cell"></td>
                                <td>
                                  {{ provider.lastName }}
                                  {{ provider.firstName }}
                                </td>
                                <td>{{ provider.id }}</td>
                                <td>
                                  <ng-container *ngIf="!isViewMode">
                                    <div class="d-flex">
                                      <div
                                        ngbDropdown
                                        container="body"
                                        class="ml-auto"
                                      >
                                        <a
                                          href="javascript:void(0);"
                                          aria-label="javascript"
                                          class="standart-link-action ml-auto"
                                          ngbDropdownToggle
                                        >
                                          <i
                                            class="fas fa-chevron-circle-down"
                                          ></i>
                                        </a>
                                        <div
                                          class="padding-top"
                                          ngbDropdownMenu
                                        >
                                          <div class="dropdown-menu-inside">
                                            <button
                                              type="button"
                                              ngbDropdownItem
                                              (click)="editProvider()"
                                            >
                                              Edit Provider
                                            </button>
                                            <button
                                              type="button"
                                              ngbDropdownItem
                                            >
                                              Delete Provider
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    class="button ml-auto w-134px"
    [disabled]="accountForm.invalid || isLoading"
    (click)="saveAccountForm()"
  >
    {{ isViewMode ? '' : isEditMode ? 'Save &' : 'Add &' }} Close
  </button>
</div>

<ng-template #emptyRow>
  <tr>
    <td colspan="4" class="pt-3 pb-3">
      <empty-state size="sm" title="No results found"></empty-state>
    </td>
  </tr>
</ng-template>

<ng-template #accountNumberLabel>
  <div class="input-text ml-2">
    {{ account?.accountNumber }}
  </div>
</ng-template>
